export default __webpack_public_path__ + "static/media/block-4.887d076a.png";